import React, { useState } from "react";

import Header from "@app/components/3_modules/Header";
import PageTitle from "@app/components/3_modules/PageTitle";
import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import SectionSiren from "@app/components/3_modules/sections/SectionSiren";
import SectionSelectCustomer from "@app/components/3_modules/sections/SectionSelectCustomer";
import SectionCreateCustomer from "@app/components/3_modules/sections/SectionCreateCustomer";
import SectionTop from "@app/components/3_modules/sections/SectionTop";
import SectionDossierEligibles from "@app/components/3_modules/dossiers/SectionDossierEligibles";

import { Plus } from 'lucide-react';
import { buildCustomerFormDataBuilder } from "@app/utils/form_data_builders/CustomerFormDataBuilder";
import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { initDossierObject, buildDossierFormDataBuilder } from "@app/utils/form_data_builders/DossierFormDataBuilder";
import { useNavigate } from "react-router-dom";
import { useToast } from '@app/components/3_modules/ToastContainer';
import { useTranslation } from "react-i18next";



export default function Home() {
    const [displayingNewSection, setDisplayingNewSection] = useState(false);
    const auth = useAuth();
    const navigate = useNavigate();

    const toast = useToast(); 
	const { t } = useTranslation();

    function displayNewCustomerSection(event) {
        event.preventDefault();
        setDisplayingNewSection(!displayingNewSection);
    }

    function createCustomer(customer) {
        const formData = buildCustomerFormDataBuilder(customer);

        apiCall ({
            method: "post",
            path: `/api/v1/customers`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {                
                createDossier(response.data.customer);
            },
            onError: (error) => {
                error.response.data.messages.forEach(message => {
                    toast.addToast(
                        "Erreur",
                        t(message)                  
                    );
                });
            }
        });
    }

    function createDossier(customer) {
        let dossier = initDossierObject();

        // Build simple dossier
        dossier.customer_id = customer.id;
        
        customer.structures.forEach((st) => {
            let structure_data = {structure_id: null};

            structure_data.structure_id = st.id;
            
            dossier.structure_datas.push(structure_data);
        })
        const formData = buildDossierFormDataBuilder(dossier);

        apiCall ({
            method: "post",
            path: `/api/v1/dossiers`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {      
                navigate(`/customers/${response.data.dossier.customer.id}`);
            }
        });
    }

    function displayNewSection() {
        if (displayingNewSection) {
            return (
                <>
                    <SectionSiren createCustomer={createCustomer} />
                    <div className="gray-line"></div>
                    <SectionSelectCustomer />
                    <div className="gray-line"></div>
                    <SectionCreateCustomer createCustomer={createCustomer} />
                </>
            )
        }
    }

    return (
        <div>
            <SectionTop />
            <PageTitle
                title="Gestion des dossiers"
                subtitle="Créez et gérez vos dossiers CSPE"                
            />
            <Header />
            <section className="page-section">
                <SectionTitle
                    icon={<Plus />}
                    title="Ajouter un nouveau dossier"
                    onClick={displayNewCustomerSection}
                />
                {displayNewSection()}                
            </section>
            <SectionDossierEligibles />
        </div>
    )
}